/** Backend API wrapper */

// prod
function get_base_domain() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        return "http://localhost:8000" //"https://api.convo4.soclearn.org"
    } else {
        return "https://api.convolution.soclearn.org"
    }

}

export const base_domain = get_base_domain()

const base_url = `${base_domain}/api/`

import { FileTransfer } from '@capacitor/file-transfer';
import { get } from './preferences'

const _fetch = window.fetch;
const fetch = async (url: string, options = {}) => {
    return await _fetch(url, { credentials: "include", ...options })
}

// docs

export async function dir_create(name: string, parent_id: number | null = null) {
    const r = await fetch(base_url + 'dirs',
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ name, parent_id })
        }
    )
    const data = await r.json()

    return data
}

interface DirGetParams {
    search?: string
    offset?: number
    limit?: number
}

export async function dir_get(id: number | string | null, params: DirGetParams = {}) {
    const url = base_url + (id ? `dirs/${id}` : `dirs`);

    params.limit = 'limit' in  params ? params.limit : 20;
    params.offset = 'offset' in params ? params.offset : 0;
    const q = (new URLSearchParams(params)).toString();
    console.log("q", q)
    const r = await fetch(url + "?" + q);
    const data = await r.json();
    return data
}

export async function dir_get_documents(id: number | string | null, repo_id: string, params: DirGetParams = {}) {
    const url = base_url + (id ? `dirs/${id}` : `dirs`) + `/${repo_id}`;

    params.limit = 'limit' in  params ? params.limit : 20;
    params.offset = 'offset' in params ? params.offset : 0;
    const q = (new URLSearchParams(params)).toString();
    console.log("q", q)
    const r = await fetch(url + "?" + q);
    const data = await r.json();
    return data
}

export async function dir_delete(id: number | string) {
    await fetch(base_url + `dirs/${id}`, { method: "DELETE" })
}

interface DirChange {
    name?: string
    description?: string
    visibility?: string
}

export async function dir_change(id: number, params: DirChange) {
    const r = await fetch(`${base_url}dirs/change/${id}`,
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params)
        }
    )
    const data = await r.json()

    return data
}

async function upload_doc(file: File, onProgress: null | ((progress: number) => void) = null, dir_id: string | null = null) {
    const user_id = await get("user_id")
    const user_key = await get("user_key")
    const url = base_url + "docs" + `?last_modified=${file.lastModified}&user_id=${user_id}&user_key=${user_key}` + (dir_id ? `&dir_id=${dir_id}` : '') // FIXME: probably a hack, also need user_key maybe? otherwise anyone can upload to this user; or maybe that's a feature idk
    const filePath = file.name;
    if (onProgress) {
        await FileTransfer.addListener("progress", (progress) => {
            // Update progress state with the percentage
            onProgress(progress.bytes/progress.contentLength);
        });
    }
    await FileTransfer.uploadFile({
        url,
        path: filePath,
        blob: file,
        progress: true
    })
}

async function docs(folder_id: number | null) {
    const r = await fetch(base_url + `docs` + folder_id ? `?folder=${folder_id}` : "")
    const data = await r.json();
    return data
}

export function get_doc_thumb_url(doc_id: number) {
    return `${base_domain}/api/docs/${doc_id}/thumb.png`
}

async function toc(doc_id: number) {
    const r = await fetch(base_url + `docs/${doc_id}/toc`)
    const data = await r.json();

    return data.toc;
}

async function dir_nav(doc_id: number) {
    const r = await fetch(base_url + `docs/${doc_id}/dir_nav`)
    const data = await r.json();

    return data;
}

async function dir_set_logo(dir_id: string, file: File) {
    const user_id = await get("user_id")
    const user_key = await get("user_key")
    const url = base_url + `dirs/${dir_id}/logo` + `?last_modified=${file.lastModified}&user_id=${user_id}&user_key=${user_key}` + (dir_id ? `&dir_id=${dir_id}` : '') // FIXME: probably a hack, also need user_key maybe? otherwise anyone can upload to this user; or maybe that's a feature idk
    const filePath = file.name;
    await FileTransfer.uploadFile({
        url,
        path: filePath,
        blob: file,
        progress: true
    })
}

export function dir_thumb_url(dir_id: number) {
    return `${base_domain}/api/dirs/${dir_id}/thumb?${new Date().getTime()}`
}

async function nav_toc(doc_id: number) {
    const r = await fetch(base_url + `docs/${doc_id}/nav_toc`)
    const data = await r.json();

    return data.toc;
}

async function chapter_lessons(doc_id: number, chapter_id: number) {
    const r = await fetch(base_url + `docs/${doc_id}/chapter_lessons/${chapter_id}`)
    const data = await r.json()

    return data.chapter_lessons
}

// tracing

export interface Message {
    role: string //"system" | "user" | "assistant" | "tool"
    type: "text" | "image" | "audio"
    content: string
    edited?: boolean
    original?: string
}

async function chat_save(messages: Message[], chat_id: number | null, doc_id: number, doc_lesson_id: string) {
    const r = await fetch(base_url + 'docs/chat',
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ messages, chat_id, doc_id, doc_lesson_id })
        }
    )
    console.log({ messages, chat_id, doc_id, doc_lesson_id })
    const data = await r.json()

    return data.id
}

async function chat_get(chat_id: number | null) {
    const r = await fetch(base_url + `docs/chat/${chat_id}`);
    const data = await r.json()

    return data.messages
}

export async function save_voice_msg(chat_id: string | null, msg_id: number, voice_msg: string) {
    const r = await fetch(base_url + 'docs/chat/voice_msg',
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                chat_id,
                msg_id,
                voice_msg
            })
        }
    )

    const data = await r.json()
    return data.chat_id
}

// legacy

async function fetch_legacy_doc(doc_id, doc_name) {
    const r = await fetch(base_url + `docs/legacy?user_id=${doc_id}&doc_id=${doc_name}` )
    return await r.json();
}

// chat

// onboarding

async function onboarding_signup(email, password, parent_email) {
    const r = await fetch(base_url + 'onboarding/signup',{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email,
            password,
            parent_email
        })
    })
    const data = await r.json()

    return data
}

async function onboarding_login(email, password) {
    const r = await fetch(base_url + 'onboarding/login',{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email,
            password
        })
    })
    const data = await r.json()

    return data
}

async function onboarding_save_data(data) {
    await fetch(base_url + 'onboarding',{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
}

async function onboarding_pay_btc() {
    const r = await fetch(base_url + 'onboarding/pay_btc',{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        }
    })
    const data = await r.json()
    console.log('onboarding_pay_btc', r, r.status, data)

    return data.checkoutLink
}

// roles

async function llm_roles_create(name: string, description: string, instructions: string, setup_code: string) {
    await fetch(base_url + 'llm_roles', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            name,
            description,
            instructions,
            setup_code
        })
    })
}

async function llm_roles_index() {
    const r = await fetch(base_url + 'llm_roles');
    const data = await r.json();
    return data
}

export default {
    dir_create, dir_get, dir_get_documents, dir_change, dir_delete,
    upload_doc, docs,
    toc, dir_nav, dir_set_logo, dir_thumb_url, nav_toc, chapter_lessons,
    chat_save, chat_get, save_voice_msg,
    fetch_legacy_doc,
    onboarding_signup, onboarding_login, onboarding_save_data, onboarding_pay_btc,
    llm_roles_create, llm_roles_index
}
